import { EMPRESAS, Tenant } from "../constants/empresas";

export function getEmpresa(tenant: string): string {
  return EMPRESAS[tenant as Tenant];
}
